<template>
  <v-btn v-on="$listeners" v-bind="defaultConfigs">
    <slot />
  </v-btn>
</template>
<script>
export default {
  computed: {
    defaultConfigs() {
      return Object.assign(
        {
          dense: true
        },
        {
          ...this.$attrs,
          ...this.$props
        }
      );
    }
  }
};
</script>
<style lang="sass">
.v-btn
  text-transform: none !important
  border-radius: 2px !important
.v-btn:not(.v-btn--round).v-size--default
  height: 40px
  font-size: 12px !important
</style>
